import Stories from "@/components/site/Stories";
import { Stethoscope } from "lucide-react";

// Playlist: Doctors About LifeWave
const ITEMS = [
  { title: "Beyond The Surface X39", youtubeId: "Xb9Icxz9xEY" },
  { title: "Dr. Panel (LifeWave)", youtubeId: "ynuAHVlXUhU" },
  { title: "Why A Doctor Uses X39 | Dr. Leland Stillman", youtubeId: "zAMe2JQrgp4" },
  { title: "Patients Experiencing Results With X39 | Dr. Tony Smith", youtubeId: "xoLW5zOCJNI" },
  { title: "X39 Doctor Testimony | Dr. Jake Davidson", youtubeId: "vHOD62iF-EA" },
  { title: "LifeWave X39 Copper Peptides | Dr. Leland Stillman", youtubeId: "qw_VDmMa8C8" },
  { title: "Dr. Larry", youtubeId: "AFSHJh_k8qY" },
  { title: "Why Would A Doctor Join LifeWave? | Dr. Pam Grover", youtubeId: "XYa4Mm6xrUQ" },
  { title: "X39 Biggest Medical Breakthrough | Dr. Joseph", youtubeId: "ptA6W8r-Q0w" },
  { title: "Dr. Willie & Dr. Rhonda Testimony | LifeWave X39", youtubeId: "junp7x7P2To" },
];

export default function WhyADoctor() {
  return (
    <Stories
      id="doctors"
      testid="why-a-doctor-section"
      label="∙ Clinical voices"
      title="Why A"
      highlight="Doctor?"
      description="Why would a doctor join LifeWave? Hear their stories and find out. Click each item to watch."
      Icon={Stethoscope}
      items={ITEMS}
    />
  );
}
